define.alias("shared/components/shared/post/secondary/caption-writer/disclaimer", "media/components/shared/post/secondary/caption-writer/disclaimer");